/*
 File: src/utils/nodeAddress.js
 Title: Node Address Conversion Utility
 Purpose: Converts Conductor-format node address strings ($NNNN$Q1-Q2-Q3-Q4) to the
          40-character lowercase hex string (node_address_hex) used as the primary key
          in devices-api-rs and the RethinkDB link-labs.devices table.
          The encoding mirrors the Rust to_binary() method in the node-address crate
          (link-labs-shared-crates/node-address/src/lib.rs).
 Copyright (c) 2026 Geotab Inc. All rights reserved.
*/

/* global BigInt */
export function toNodeAddressHex(nodeAddress) {
  if (!nodeAddress || typeof nodeAddress !== 'string') return null;
  if (!nodeAddress.startsWith('$')) return null;

  const inner = nodeAddress.slice(1);
  const dollarIdx = inner.indexOf('$');
  if (dollarIdx === -1) return null;

  const nodeTypeHex = inner.slice(0, dollarIdx);
  const quads = inner.slice(dollarIdx + 1).split('-');
  if (quads.length !== 4) return null;

  const nodeType = parseInt(nodeTypeHex, 16);
  if (isNaN(nodeType)) return null;

  try {
    const q1 = BigInt('0x' + (quads[0] || '0'));
    const q2 = BigInt('0x' + (quads[1] || '0'));
    const q3 = BigInt('0x' + (quads[2] || '0'));
    const q4 = BigInt('0x' + (quads[3] || '0'));

    const id = (q1 << 96n) | (q2 << 64n) | (q3 << 36n) | q4;

    const nodeTypeBytes = nodeType.toString(16).padStart(8, '0');
    const idBytes = id.toString(16).padStart(32, '0');
    return nodeTypeBytes + idBytes;
  } catch {
    return null;
  }
}
